import script from "./TransactionsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsTab.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsTab.vue?vue&type=style&index=0&id=414691ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-414691ce"]])

export default __exports__